import React from 'react';
import PropTypes from 'prop-types';
import {GlossaryDispatch} from '../../Glossary';
import {ChevronIcon} from '../ChevronIcon';
import style from './style.module.scss';

export function MobileIndexBlock() {
  const {toggleIndexCollapse} = React.useContext(GlossaryDispatch);

  const onIndexClick = () => {
    toggleIndexCollapse();
  };

  return (
    <div className={style.mobileIndexBlock} onClick={onIndexClick}>
      <ChevronIcon className={style.mobileIndexBlock_icon} />
      index
    </div>
  );
}
